module.exports = __webpack_public_path__ + "img/ThumbSpicaWrist.f72c0150.svg";